<template>
    <div v-click-outside="onCancel">
        <div @click="open">
            <img
                v-if="cropLoading"
                ref="previewImage"
                width="100px"
                height="auto"
                :src="
                    options.imageToCropPreview +
                        '?' +
                        Math.floor(Math.random() * 100000)
                "
                class="img-thumbnail"
            />
            <img
                v-if="!cropLoading"
                ref="previewImage"
                width="100px"
                height="auto"
                :src="
                    options.imageToCropPreview +
                        '?' +
                        Math.floor(Math.random() * 100000)
                "
                class="img-thumbnail"
            />
        </div>
        <div v-if="show">
            <transition name="modal">
                <div class="modal-mask centered-modal">
                    <div class="modal-wrapper">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button
                                        type="button"
                                        class="close"
                                        @click="onCancel"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title">Resim</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="cropper-area">
                                        <vue-cropper
                                            ref="cropper"
                                            :src="options.imageToCropPreview"
                                            :zoomable="false"
                                            :aspectRatio="options.aspectRatio"
                                            :autoCrop="true"
                                            :autoCropArea="0.99"
                                            :cropmove="move"
                                            :ready="ready"
                                            :checkCrossOrigin="false"
                                            :checkOrientation="false"
                                            :viewMode="1"
                                        ></vue-cropper>
                                    </div>
                                </div>
                                <footer>
                                    <div v-show="!cropLoading">
                                        <a class="btn" @click="onCancel"
                                            >Cancel</a
                                        >
                                        <a class="btn" @click="crop">Crop</a>
                                    </div>
                                    <div v-show="cropLoading">
                                        Kesiliyor...
                                    </div>
                                </footer>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script type="javascript">

import ClickOutside from 'vue-click-outside'
import VueCropper from 'vue-cropperjs'
import service from './service'

export default {
    name: 'ImageCropper',
    props: ['token', 'options'],
    components: {
        VueCropper
    },
    data() {
        return {
            show: false,
            minCropWidth: null,
            minCropHeight: null,
            cropLoading: false,
            service,
            croppedImage: null
        }
    },
    methods: {
        open(){
            if (confirm('Crop işleminden sonra sayfa yenilenecektir. Tüm bilgilerinizi kaydettiğinize emin olun. Hala devam etmek istiyor musunuz?')) {
                this.show = true;
            }
        },
        ready(){
            let previewImageData = this.$refs.cropper.getImageData()
            let widthRatio = this.options.image.width / previewImageData.width
            let heightRatio = this.options.image.height / previewImageData.height

            this.minCropWidth = Math.floor(Math.round(this.options.minWidth / widthRatio))
            this.minCropHeight = Math.floor(Math.round(this.options.minHeight / heightRatio))
        },
        move(e) {
            if (e.target.cropper.cropBoxData.width <= this.minCropWidth) {
                e.target.cropper.cropBoxData.minWidth = this.minCropWidth
            }

            if (e.target.cropper.cropBoxData.height <= this.minCropHeight) {
                e.target.cropper.cropBoxData.minHeight = this.minCropHeight
            }
        },
        crop() {
            let cropBoxData = this.$refs.cropper.getData(),
                previewImageData = this.$refs.cropper.getImageData()

            let ratio = this.options.image.height / previewImageData.naturalHeight

            let cropX = (cropBoxData.x <= 1) ? 1 : cropBoxData.x,
                cropY = (cropBoxData.y <= 1) ? 1 : cropBoxData.y

            this.cropLoading = true
            this.$refs.previewImage.src = ''
            this.onCancel()
            service
                .request({
                    url: '/helpers/crop',
                    type: 'POST',
                    token: this.token,
                    body: {
                        'key': this.options.image.key,
                        'x': Math.floor(cropX * ratio),
                        'y': Math.floor(cropY * ratio),
                        'w': Math.floor(cropBoxData.width * ratio) - 2,
                        'h': Math.floor(cropBoxData.height * ratio) - 2,
                        'artefactType': this.options.artefactType,
                        'artefactId': this.options.artefactId,
                        'artefactImageIndex': this.options.artefactImageIndex
                    }
                })
                .then(response => {
                    setTimeout(() => {
                        this.$nextTick(()=> {
                            //refresh image
                            const random = Math.floor(Math.random() * 100000)
                            this.$refs.previewImage.src = response.data.thumbnail + '?' + random
                            this.options.imageToCropPreview = response.data.thumbnail + '?' + random
                            this.cropLoading = false;
                            this.$forceUpdate()

                            //refresh cropper info with new data
                            this.options.image.width = Math.floor(cropBoxData.width * ratio) - 2
                            this.options.image.height = Math.floor(cropBoxData.height * ratio) - 2

                            window.location.reload();
                        })
                    }, 5000)
                })
        },
        onCancel() {
            this.show = false
        },
    },
    mounted(){

    },
    beforeDestroy() {

    },
    beforeRouteUpdate(to, from, next) {

    },
    directives: {
        ClickOutside
    }
}
</script>

<style lang="css">
.modal-dialog > div {
    width: 100%;
    display: block;
}

.cropper-area {
    margin: 0 auto;
}

.modal-dialog footer {
    margin-top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-dialog footer button {
    margin: 0 10px;
}

.fileinput .modal-mask.centered-modal {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 99999999;
    overflow: scroll;
}

.fileinput .modal-mask.centered-modal .modal-dialog {
    max-width: 70%;
}
</style>



// WEBPACK FOOTER //
// resources/vue/image-cropper.vue